import axios from "axios";
import vm from '@/main';
import { getDeviceId } from '@/utils'

function clearLoginInfo(){
  vm.$storage.delete('user_info');
  vm.$storage.delete('user_token');
  vm.$isLogin && vm.$isLogin();
}

var instance = axios.create({
  timeout: 1000 * 10,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  }
});

/**
 * 请求拦截
 */
instance.interceptors.request.use(
  (config) => {
    // config.headers["token"] = Vue.cookie.get("token"); // 请求头带上token
    let tokenData = vm.$storage.get('user_token') || ''
    if(tokenData){
      config.headers["Authorization"] = `bearer ${tokenData}`; // 请求头带上token
    }
    config.headers["deviceId"] = getDeviceId()
    
    // //@todo  22-01-25 与服务端约定 - 测试时devicesystem传1 ，上线后传4
    // config.headers["devicesystem"] = !['sss.shopshops.top', 'm.shopshops.top'].includes( location.hostname ) ? 1 : 4;
    //@todo  22-04-08 devicesystem 必须是4，否则test环境接口一直报错。具体原因不详。后续再查
    config.headers["devicesystem"] = 4;

    config.headers["currentLocaleLanguageCode"] = vm.$i18n.locale === 'en' ? 'en':'zh';

    // config.headers["appLanguge"] = vm.$i18n.locale === 'en' ? 'en':'zh';
    // config.headers["platformType"] = 'H5'
    // config.headers["time"] = new Date().toDateString()
    // config.headers["$url"] = window.location.href
    // const titleMap = {
    //   "/home/Live":"首页直播列表",
    //   "/home/Upcoming":"首页预告列表",
    //   "/home/Replay":"首页回放列表",
    //   "/room":"直播详情",
    //   "/profile":"个人资料",
    //   "/cart":"购物车",
    //   "/goods_detail":"商品详情",
    //   "/order_list":"订单列表",
    //   "/order_detail":"订单详情",
    //   "/repay":"支付页",
    //   "/logistics":"物流详情",
    //   "/nimChat":"云信聊天",
    //   "/store":"店铺详情",
    //   "/anchor":"主播详情"
    // }

    // let title = ''
    // let path = ''

    // for (const key in titleMap) {
    //   if (Object.hasOwnProperty.call(titleMap, key)) {
    //     if (window.location.href.indexOf(key) > -1) {
    //       title = titleMap[key]
    //       path = key
    //     }
    //   }
    // }
    // config.headers["$title"] = title
    // config.headers["path"] = `/app${path}`
  
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      let res = response.data

      switch (res.code) {
        // todo must login
        case 100006:
          // console.error('must login')
          break;

        // 用户校验失败
        case 505001: 
          // 退出登录
          clearLoginInfo();
          break;
        // 账号已禁用
        case 505328: 
          // 退出登录
          clearLoginInfo();
          break;
        default:;
      };
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // todo response
        case 404:
          return;
        case 500:
          break;
        default:;
      }
      return Promise.reject(error.response);
    }else{
      return Promise.reject(error);
    }
  }
);

export default {
  get: (url, params={}) => {
    return new Promise((resolve, reject) => {
      instance
        .get(url, {
          params: params
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post: (url, params={}) => {
    return new Promise((resolve, reject) => {
      instance
        // .post(url, Qs.stringify(params)) // 这里已经序列化
        .post(url, params) // 这里已经序列化
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
